import { render, staticRenderFns } from "./AadharCardScan.vue?vue&type=template&id=6fddcabe&"
import script from "./AadharCardScan.vue?vue&type=script&lang=js&"
export * from "./AadharCardScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports